import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import gql from 'graphql-tag';
import {
  MutationStatus,
  MutationUpdateTenantAccountFeatureFlagsArgs,
  UpdateTenantAccountFeatureFlagsInput,
} from '../gql-types.generated';
import { getStandardHeaders } from '../util/StandardRequestHeaders';

// eslint-disable-next-line @typescript-eslint/naming-convention
const MUTATION_UPDATE_TENANT_ACCOUNT_FEATURE_FLAGS = gql`
  mutation updateTenantAccountFeatureFlags($input: UpdateTenantAccountFeatureFlagsInput!) {
    updateTenantAccountFeatureFlags(input: $input) {
      code
      message
      error
    }
  }
`;

export const mutationUpdateTenantAccountFeatureFlags = async (
  client: ApolloClient<NormalizedCacheObject>,
  tenantId: string,
  input: UpdateTenantAccountFeatureFlagsInput,
): Promise<MutationStatus | undefined> => {
  const baseHeaders = await getStandardHeaders(true);
  const headers = { ...baseHeaders, 'x-aptean-tenant': tenantId };
  const { data, errors } = await client.mutate<
    { updateTenantAccountFeatureFlags: MutationStatus },
    MutationUpdateTenantAccountFeatureFlagsArgs
  >({
    variables: { input },
    mutation: MUTATION_UPDATE_TENANT_ACCOUNT_FEATURE_FLAGS,
    context: { headers },
  });

  if (errors && errors.length > 0) {
    errors.forEach(error => console.error(error));
    throw new Error('An error has occurred during the feature flags update.');
  }

  return data?.updateTenantAccountFeatureFlags;
};
